import { Column, Entity, OneToMany } from 'typeorm';
import { BaseEntity } from './base.entity';
import { ShipmentEntity } from './shipment.entity';

@Entity('carrier')
export class CarrierEntity extends BaseEntity {
	@Column('varchar', { name: 'externalId', nullable: true, length: 255 })
	public externalId!: string | null;

	@Column('varchar', { name: 'name', length: 255 })
	public name!: string;

	@Column('varchar', { name: 'trackingUrl', nullable: true, length: 255 })
	public trackingUrl!: string | null;

	@Column('datetime', { name: 'lastImportDate', nullable: true })
	public lastImportDate!: Date | null;

	@OneToMany(() => ShipmentEntity, (shipment) => shipment.fkCarrier, {})
	public shipments!: Array<ShipmentEntity>;
}
